export const SOCKET_TYPE_UNKNOWN = 'socket-type-unknown';

export const CHAT_ACTIVITY_TYPING_EVENT_NAME = 'client-kustomer.app.chat.activity.typing';

export const CONVERSATION_TYPE = 'conversation';
